(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-nv-image]');
  if (!button) return;
  const main = button.closest('[data-nv-product]').querySelector('.nv-product-main');
  if (main) { main.removeAttribute('srcset'); main.src = button.dataset.nvImage; main.alt = button.querySelector('img').alt; }
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-nv-variant]')) return;
  const url = new URL(window.location.href); url.searchParams.set('variant', event.target.value); window.location.href = url.toString();
});

  } catch(e) { console.error(e); }
})();
})();
